/// <reference path="../../../app.definition.ts" />

function uibMaxLen(): ng.IDirective {
  return {
    restrict: 'A',
    link: function (scope, element, attr) {
      if (!!attr.uibMaxLen && attr.uibMaxLen != "-1") {
        const $uiSelect = element.find('.ui-select-search');
        $uiSelect.attr("maxlength", attr.uibMaxLen);
      }
    }
  }
}
angular.module('eCareVault.common.directives').directive('uibMaxLen', uibMaxLen);
